import { render, staticRenderFns } from "./GLTransactionAddingForm.vue?vue&type=template&id=0a0df5b0"
import script from "./GLTransactionAddingForm.vue?vue&type=script&lang=js"
export * from "./GLTransactionAddingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports